// extracted by mini-css-extract-plugin
module.exports = {"favoriteButton":"Favorite_favoriteButton__2D1Vu","favorited":"Favorite_favorited__3213C","favoriteLoading":"Favorite_favoriteLoading__chrMi"};